import "./VideoCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlayCircle,
  faCalendarAlt,
  faEdit,
  faTimes,
  faComment,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "react";
import { campaignFetcher, videoFetcher } from "../../../api/requests";
import LogoutModal from "../../Navigation/LogoutModal";
import { useToaster } from "../../../context/toaster";
import { baseURL } from "../../../api/dataFetcher";
import { Button } from "react-bootstrap";
import { useSelectedVideos } from "../../../context/selectedVideos";
import Modal from "../Modal";
import { AuthContext } from "../../../context/auth";
import LoadingIndicator from "../Loading/Loading";

function VideoCard({
  iconHref = "#",
  imgHref = "#",
  imgSrc,
  imgAlt = "",
  time = "-:-",
  videoTitle = "#",
  videoTitleHref,
  views,
  timeAgo,
  videoCategory,
  verified = null,
  featured = false,
  channelName,
  channelId,
  mine,
  admin,
  videoId,
  onDelete,
  totalLikes,
  totalSaves,
  totalShares,
  totalComments,
  totalDislikes,
  select = false,
  campaign = false,
  videoRate,
  sidebar = false,
  videoPublisher,
  repost = false,
}) {
  const [showDel, setShowDel] = useState(false);
  const { addMessage } = useToaster();
  const { addVideo, removeVideo, isVideoSelected, isVideoLoading } =
    useSelectedVideos();
  const [showRate, setShowRate] = useState(false);
  const [rate, setRate] = useState(videoRate);
  const { user } = useContext(AuthContext);

  const handleClose = () => {
    setShowDel(false);
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleDelete = async () => {
    try {
      const res = await (campaign
        ? campaignFetcher.deleteVideo(videoId)
        : videoFetcher.delete(videoId));
      setShowDel(false);
      window.location.reload();
      showToast("success", "ویدئو با موفقیت حذف شد.");
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  const handleVideoSelection = () => {
    if (isVideoSelected(videoId)) {
      removeVideo(videoId);
    } else {
      addVideo(videoId);
    }
  };

  const handleRateClick = async () => {
    try {
      if (rate >= 0) {
        const res = await campaignFetcher.campaignRateEdit(
          { video_rate: rate },
          videoId
        );
        showToast("success", res.message);
        setShowRate(false);
      } else {
        showToast("error", "عدد انتخاب شده درست نمی باشد.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        title={videoTitle}
        className="video-card fullHeight"
        style={{
          boxShadow: featured ? "0 0 11px #ececec" : "0 0 11px #ececec",
          display: !sidebar && "flex",
          flexDirection: !sidebar && "column",
          height: !sidebar && "100%",
        }}
      >
        <div
          className="video-card-image"
          style={{
            boxShadow: featured ? "0 0 11px #ececec" : "0 0 11px #ececec",
            minHeight: "120px",
            heig: "42%",
          }}
        >
          <a className="play-icon" href={iconHref}>
            <FontAwesomeIcon icon={faPlayCircle} />
          </a>
          <a href={imgHref}>
            <div
              className="videoImage"
              style={{
                maxWidth: "100%",
                height: "140px",
                objectFit: "cover",
              }}
            >
              <img
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                src={
                  imgSrc
                    ? imgSrc.includes("vaghfnama.ir")
                      ? imgSrc
                      : baseURL + imgSrc
                    : "/img/v4.png"
                }
                alt={imgAlt}
              />
            </div>
          </a>
          {/* <div className="time">{time}</div> */}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            justifyContent: "space-between",
          }}
        >
          <div className="video-card-body" style={{ paddingBottom: "0px" }}>
            <div className="video-title">
              <a href={`${videoTitleHref}`} title={videoTitle}>
                {videoTitle?.length > 45
                  ? videoTitle.slice(0, 45) + "..."
                  : videoTitle}
              </a>
            </div>
            <a
              href={
                campaign
                  ? `/single-channel/${channelId}/?campaign=true`
                  : `/single-channel/${channelId}/`
              }
              className={"video-page text-primary"}
              title={channelName}
            >
              {channelName?.length > 50
                ? channelName.slice(0, 50) + "..."
                : channelName}
            </a>
            {campaign && videoPublisher && (
              <div style={{ color: "gray" }} className="video-page">
                ارسال شده توسط: <strong>{videoPublisher}</strong>
              </div>
            )}
            <div
              className={
                verified
                  ? "video-page text-success-custom"
                  : "video-page text-danger-custom"
              }
            >
              {videoCategory}
              {/* {verified ? <VerifiedTooltip /> : <UnverifiedTooltip />} */}
            </div>
            {views >= 0 && (
              <span className="video-view mb-2">{views} بازدید &nbsp;</span>
            )}
            {totalLikes >= 0 && (
              <span className="video-view mb-2">{totalLikes} لایک &nbsp;</span>
            )}
            {totalDislikes >= 0 && (
              <span className="video-view mb-2">
                {totalDislikes} دیسلایک &nbsp;
              </span>
            )}
            {totalSaves >= 0 && (
              <span className="video-view mb-2">{totalSaves} ذخیره &nbsp;</span>
            )}
            {totalShares >= 0 && (
              <span className="video-view mb-2">
                {totalShares} اشتراک &nbsp;
              </span>
            )}
            {totalComments >= 0 && (
              <span className="video-view mb-2">
                {totalComments} نظر &nbsp;
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              padding: "0px 12px",
            }}
          >
            <div className="video-view mb-2" style={{ textAlign: "right" }}>
              <FontAwesomeIcon className="ml-1" icon={faCalendarAlt} />
              <span>{timeAgo}</span>
            </div>

            {campaign && user?.permissions?.includes("campaign")
              ? mine && (
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      flexDirection: "row",
                      marginBottom: "12px",
                    }}
                  >
                    <a
                      href={
                        campaign
                          ? `/video-edit/${videoId}/?campaign=true`
                          : repost
                          ? `/video-edit/${videoId}/?repost=true`
                          : `/video-edit/${videoId}/`
                      }
                      className="edit"
                      title="ویرایش ویدئو"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </a>
                    {campaign &&
                      user?.permissions?.includes("rate_video_campaign") &&
                      (user.role === "is_superuser" ||
                        user.role === "is_supervisor") && (
                        <span
                          onClick={() => setShowRate(true)}
                          className="edit"
                          title="امتیاز دادن به ویدئو"
                        >
                          <FontAwesomeIcon
                            style={{ marginRight: "2px" }}
                            icon={faStar}
                          />
                        </span>
                      )}
                    {!repost && (
                      <a
                        className="videoComment"
                        title="مدیریت نظرات"
                        href={`/comments-management/${videoId}`}
                      >
                        <FontAwesomeIcon icon={faComment} />
                      </a>
                    )}

                    {admin === "false" && (
                      <span
                        className="delete"
                        title="حذف ویدئو"
                        onClick={() => setShowDel(true)}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </span>
                    )}
                  </div>
                )
              : !campaign &&
                mine && (
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      flexDirection: "row",
                      marginBottom: "12px",
                    }}
                  >
                    <a
                      href={
                        campaign
                          ? `/video-edit/${videoId}/?campaign=true`
                          : repost
                          ? `/video-edit/${videoId}/?repost=true`
                          : `/video-edit/${videoId}/`
                      }
                      className="edit"
                      title="ویرایش ویدئو"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </a>
                    {campaign &&
                      user?.permissions?.includes("rate_video_campaign") &&
                      (user.role === "is_superuser" ||
                        user.role === "is_supervisor") && (
                        <span
                          onClick={() => setShowRate(true)}
                          className="edit"
                          title="امتیاز دادن به ویدئو"
                        >
                          <FontAwesomeIcon
                            style={{ marginRight: "2px" }}
                            icon={faStar}
                          />
                        </span>
                      )}
                    {!repost && (
                      <a
                        className="videoComment"
                        title="مدیریت نظرات"
                        href={`/comments-management/${videoId}`}
                      >
                        <FontAwesomeIcon icon={faComment} />
                      </a>
                    )}

                    {admin === "false" && (
                      <span
                        className="delete"
                        title="حذف ویدئو"
                        onClick={() => setShowDel(true)}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </span>
                    )}
                  </div>
                )}

            {select && (
              <Button
                style={{
                  fontSize: "14px",
                  padding: "1px 5px",
                  width: "fit-content",
                  marginBottom: "12px",
                }}
                onClick={() => handleVideoSelection(videoId)}
              >
                {isVideoLoading(videoId) ? (
                  <LoadingIndicator size="sm" padding="2px 2px" />
                ) : isVideoSelected(videoId) ? (
                  "✓"
                ) : (
                  "انتخاب ویدئو"
                )}
              </Button>
            )}
          </div>
        </div>
      </div>

      <Modal isOpen={showRate} onClose={() => setShowRate(false)}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "18px",
            gap: "5px",
          }}
        >
          <h6>امتیاز ویدئو</h6>
          <input
            value={rate}
            type="number"
            min={0}
            onChange={(e) => setRate(e.target.value)}
          />
          <Button
            style={{ fontSize: "14px", padding: "1px 5px" }}
            onClick={handleRateClick}
          >
            ثبت
          </Button>
        </div>
      </Modal>

      {showDel && (
        <LogoutModal
          show={showDel}
          type="delete"
          name="ویدئو"
          handleClose={handleClose}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
}

export default VideoCard;
